import {
  IDashboardItem,
  IMenuItem,
} from "../interfaces/user-dashboard.interface";
import { ReactComponent as clubs } from "../../assets/clubs.svg";
import { ReactComponent as treasuries } from "../../assets/treasuries.svg";
import { ReactComponent as proposals } from "../../assets/proposals.svg";
import { ReactComponent as withdrawals } from "../../assets/withdrawals.svg";
import { ReactComponent as deposits } from "../../assets/deposits.svg";
import { ReactComponent as staking } from "../../assets/staking.svg";
import { ReactComponent as invitations } from "../../assets/dashboardInvitations.svg";
import { ReactComponent as rewards } from "../../assets/rewards.svg";
import { ReactComponent as clubOverview } from "../../assets/clubOverview.svg";
import { EMPTY_STRING } from "./common.constants";
import {
  DashboardActiveStep,
  DashboardItemType,
} from "../enums/dashboard.enums";

export const menuItems: IMenuItem[] = [
  {
    title: "Overview",
    icon: clubOverview,
    step: DashboardActiveStep.Dashboard,
  },
  { title: "Clubs", icon: clubs, step: DashboardActiveStep.Clubs },
  {
    title: "Treasuries",
    icon: treasuries,
    step: DashboardActiveStep.Treasuries,
  },
  { title: "Proposals", icon: proposals, step: DashboardActiveStep.Proposals },
  {
    title: "Withdrawals",
    icon: withdrawals,
    step: DashboardActiveStep.Withdrawals,
  },
  { title: "Staking", icon: staking, step: DashboardActiveStep.Staking },
  {
    title: "Pending requests",
    icon: invitations,
    step: DashboardActiveStep.Invitations,
  },
];

export const dashobardItems: IDashboardItem[] = [
  {
    icon: clubs,
    title: "Member of",
    type: DashboardItemType.Clubs,
    step: DashboardActiveStep.Clubs,
  },
  {
    icon: deposits,
    title: "Total deposits",
    type: DashboardItemType.Deposits,
    step: DashboardActiveStep.Treasuries,
  },
  {
    icon: withdrawals,
    title: "Total withdrawn amount",
    type: DashboardItemType.TotalWithdraw,
    step: DashboardActiveStep.Withdrawals,
  },
  {
    icon: withdrawals,
    title: "Available to be withdrawn",
    type: DashboardItemType.AvailalbeWithdraw,
    step: DashboardActiveStep.Withdrawals,
  },
  {
    icon: proposals,
    title: "Active proposals",
    type: DashboardItemType.ActiveProposals,
    step: DashboardActiveStep.Proposals,
  },
  {
    icon: invitations,
    title: "Pending requests",
    type: DashboardItemType.Invitations,
    step: DashboardActiveStep.Invitations,
  },
  {
    icon: staking,
    title: "Total Staked amount",
    type: DashboardItemType.StakedAmount,
    step: DashboardActiveStep.Staking,
  },
  {
    icon: rewards,
    title: "Total reward earned",
    type: DashboardItemType.Reward,
    step: DashboardActiveStep.Staking,
  },
];

export const CLUB_TABLE_COLUMNS = [
  "Role",
  "Treasury balance",
  "Financial Account balance",
  "Ownership",
  "Members",
  "Number of NFTs",
  "Active proposals",
  "Staking Accounts",
  "Applications",
];

export const MASTER_CLUB_TABLE_COLUMNS = [
  "Role",
  "Master",
  "Treasury balance",
  "Financial Account balance",
  "Ownership",
  "Members",
  "Number of NFTs",
  "Active proposals",
  "Staking Accounts",
  "Applications",
];

export const STAKING_TABLE_COLUMNS = [
  "Staking name",
  "Staking item",
  "Staking period",
  "Deposited",
  "Staking reward",
  "Status",
  EMPTY_STRING,
  EMPTY_STRING,
  EMPTY_STRING,
];

export const WITHDRAWAL_TABLE_COLUMNS = [
  "Withdrawal name",
  "Total withdrawal",
  "User withdrawal",
  "Date",
  EMPTY_STRING,
];

export const TREASURY_TABLE_COLUMNS = [
  "Role",
  "Denominated currency",
  "Treasury balance",
  "Ownership",
  "Fundraising in progress",
  "Your deposit",
  EMPTY_STRING,
];
